import { Pipe, PipeTransform } from '@angular/core';
import { displayRecordNo, RecordNoType } from './pipeline-ref.util';

@Pipe({ name: 'recordNo', standalone: true })
export class RecordNoPipe implements PipeTransform {
  transform(record: any, type: RecordNoType | string | null | undefined): string {
    return displayRecordNo(type, record);
  }
}
